import type { Offset } from '@octopus-do/octopus-project-core'
import { type RefObject, useLayoutEffect, useState } from 'react'

import { THREAD_CARD_GAP, THREAD_CARD_WIDTH } from '../constants'

export type CardSide = 'right' | 'left'

// The card opens to the right of the bubble and flips to the left when the
// screen has no room for it there. Measured once per opening and after a
// drag, not on every pan: a card jumping sides under the pointer is worse
// than one partly off screen.
export const useCardSide = (
  ref: RefObject<HTMLElement | null>,
  active: boolean,
  offset: Offset
): CardSide => {
  const [side, setSide] = useState<CardSide>('right')

  useLayoutEffect(() => {
    if (!active || !ref.current) {
      return
    }

    const { right } = ref.current.getBoundingClientRect()
    const fits =
      right + THREAD_CARD_GAP + THREAD_CARD_WIDTH <= window.innerWidth

    setSide(fits ? 'right' : 'left')
  }, [active, offset.x, offset.y])

  return side
}
